import { useState, useEffect } from 'react';
import { NoRecords, PageLoader } from '../../../lib/loader';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useReferralManage } from '../api/apiReferral';
import { useParams } from 'react-router-dom';
import { useCheckAdminAccess } from '../../WhiteIp/api/whiteipapi';
import { logout } from '../../../hooks/logout';
import PermissionDenied from '../../common/permissionDenied';
import { WaitingLoader } from '../../../hooks/buttonLoad';
import { SquarePen } from 'lucide-react';
import { Modal, ModalBody } from 'reactstrap';
import EditReferral from './ModalEditReferral';

function ReferralFeeManage() {
    const { id } = useParams();

    const { data: Rewardupdatehistory, isLoading } = useReferralManage({
        id,
        page: 0,
        size: 10,
    });

    const checkAdminMutation = useCheckAdminAccess();
    const [access, setAccess] = useState(true);
    const [selectedRow, setSelectedRow] = useState(null);


    const [open, setOpen] = useState(false)
    const toggle = () => setOpen(!open)

    useEffect(() => {
        checkAdminAccess();

    }, []);


    const checkAdminAccess = async () => {
        try {
            const obj = { page: 'Referral Management' };
            const checkAdminRes = await checkAdminMutation.mutateAsync(obj);
            if (!checkAdminRes?.data?.status) {
                setAccess(false);
                logout();
            } else {
                setAccess(true);
            }
        } catch (error) {
            setAccess(false);
        }
    };

    const handleEditClick = (rowData) => {
        setSelectedRow(rowData);
        setOpen(true);
    };


    const renderTotalReferralhistoryTable = () => (
        Rewardupdatehistory?.data?.data?.length > 0 ? (

            <div style={{ minHeight: "60vh" }}>
                <div className='table-responsive'>
                    <Table sx={{ minWidth: 650 }} aria-label="Referral transaction history table">
                        <TableHead>
                            <TableRow>
                                <TableCell align="center">S.NO</TableCell>
                                <TableCell align="center">Level Name</TableCell>
                                <TableCell align="center">Level Eligible Criteria</TableCell>
                                <TableCell align="center">Rewards Percentage (%)</TableCell>
                                <TableCell align="center"> Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {Rewardupdatehistory?.data?.data?.map((row, i) => (
                                <TableRow key={row?._id || i}>
                                    <TableCell align="center">{i + 1}</TableCell>

                                    <TableCell align="center">
                                        {row?.levelName}
                                    </TableCell>
                                    <TableCell align="center">
                                        {row?.refUserCount}
                                    </TableCell>
                                    <TableCell align="center">
                                        {row?.rewardpercent} %
                                    </TableCell>
                                    <TableCell align="center">
                                        <button onClick={() => handleEditClick(row)} style={{ cursor: "pointer", border: 'unset', background: 'unset' }}><SquarePen size={20} /></button>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
            </div>

        ) : (
            <NoRecords />
        )
    );

    let content;

    if (isLoading) {
        content = <WaitingLoader />;
    } else if (access) {
        content = (
            <>
                <section>
                    <h3>Cashback Reward Management</h3>
                    <div className="ad_pg_bx bg-white p-3">
                        <div className="d-flex justify-content-between align-items-center mb-2">

                        </div>
                        {isLoading ? <PageLoader /> : renderTotalReferralhistoryTable()}
                    </div>
                </section>

                <Modal isOpen={open} toggle={toggle} centered>
                    <div className="modal-header">
                        <h1 className="modal-title fs-5">Reward Eligibility Criteria </h1>
                        <button type="button" className="btn-close" onClick={toggle} aria-label="Close">
                            <img src={require('../../../assets/images/icons/close-circle.svg').default} alt="close-circle" />
                        </button>
                    </div>
                    <ModalBody>
                        <EditReferral toggle={toggle} rowData={selectedRow} />

                    </ModalBody>
                </Modal>
            </>
        );
    } else {
        content = <PermissionDenied />;
    }

    return <>{content}</>;




}

export default ReferralFeeManage;








